/* jshint esversion: 6 */
import React from 'react';

export default function  CCVersionModule(Component) {

    class CCVersionModule extends React.Component {
        constructor(props) {
            super(props);

            this.onMount = this.onMount.bind(this);
            this.onCheckout = this.onCheckout.bind(this);

        }

        onMount(version) {

            let term = (this.props.termLabel === "Year") ? "a" : "m",
                trialEligible = (this.props.user.detail.trialEligible) ? "-free" : "-paid";

            // if (dataLayer && this.props.sendPromoView) {
            //     dataLayer.push({
            //         'event': 'promotionView',
            //         'ecommerce': {
            //             'promoView': {
            //                 'promotions': [
            //                     {
            //                         'id': 'checkout_modal',
            //                         'name': 'Checkout Modal',
            //                         'creative': 'checkout_modal.' + version + term + trialEligible,
            //                         'position': 'payment-page'
            //                     }
            //                 ]
            //             }
            //         }
            //     });
            // }

        }

        onCheckout(e) {
            let that = this,
                term = (this.props.termLabel === "Year") ? "a" : "m",
                trialEligible = (this.props.user.detail.trialEligible) ? "-free" : "-paid",
                version = e.currentTarget.dataset.version;

            e.preventDefault();

            if (typeof this.props.buttonAction === "function") {
                let actionRef = this.props.buttonAction;
                if ((dataLayer || this.props.recordEvent) && this.props.sendPromoView) {
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Checkout Click',
                            event_data: {
                                source: 'checkout_modal.' + version + term + trialEligible
                            }
                        })
                    }

                    // if (window.ga && ga.loaded) {
                    //     dataLayer.push({
                    //         'event': 'promotionClick',
                    //         'ecommerce': {
                    //             'promoClick': {
                    //                 'promotions': [
                    //                     {
                    //                         'id': 'checkout_modal',
                    //                         'name': 'Checkout Modal',
                    //                         'creative': 'checkout_modal.' + version + term + trialEligible,
                    //                         'position': 'payment-page'
                    //                     }
                    //                 ]
                    //             }
                    //         },
                    //         eventCallback: () => {
                    //             if (actionRef) {
                    //                 actionRef.apply(this, [e]);
                    //                 actionRef = null;
                    //             }
                    //         }
                    //     });
                    // } else {
                        this.props.buttonAction.apply(this, [e]);
                    // }
                } else {
                    this.props.buttonAction.apply(this, [e]);
                }

            }

        }

        render() {
            return (
                <Component
                    {...this.props}
                    onMount={this.onMount}
                    onCheckout={this.onCheckout}/>
            );
        }
    }

    CCVersionModule.displayName = "CCVersionModule";

    return CCVersionModule;

}
